export default __webpack_public_path__ + "static/media/nike-dunk-low.babb6890.jpg";